import JobService from "../services/JobService";

export const getPageTitle = (pathname: string): string => {
  // Handle nested routes with parameters
  if (pathname.includes("/jobs/all/") && pathname.includes("/containers")) {
    if (pathname.includes("/live-tracking")) {
      return "Live Tracking";
    }
    if (pathname.includes("/containers/")) {
      return "Trip Details";
    }
    return "Containers";
  }

  // Handle job routes
  if (pathname.startsWith("/job/")) {
    if (pathname.includes("/containers")) {
      return "Containers";
    }
    if (pathname.includes("/assign-containers")) {
      return "Assign Containers";
    }
    return "Job Details";
  }

  switch (pathname) {
    case "/":
      return "Home";
    case "/live-fleet":
      return "Live fleet";
    case "/dashboard":
      return "Dashboard";
    case "/jobs":
      return "Jobs";
    case "/jobs/create-new":
      return "Create New Job";
    case "/jobs/all":
      return "All Jobs";
    case "/jobs/initiated":
      return "Initiated Jobs";
    case "/jobs/assigned":
      return "Assigned Jobs";
    case "/jobs/in-progress":
      return "In Progress Jobs";
    case "/jobs/completed":
      return "Completed Jobs";
    case "/jobs/cancelled":
      return "Cancelled Jobs";
    case "/jobs/deleted":
      return "Deleted Jobs";
    case "/jobs/history":
      return "Job History";
    case "/trips/active":
      return "Active Trips";
    case "/trips/history":
      return "Trip History";
    case "/reports":
      return "Reports";
    case "/transporters":
      return "Transporters";
    case "/drivers":
      return "Drivers";
    case "/trucks":
      return "Trucks";
    case "/fleet":
      return "Fleet";
    case "/fleet/drivers":
      return "Drivers";
    case "/fleet/trucks":
      return "Trucks";
    case "/locations":
      return "Locations";
    case "/profile":
      return "Profile";
    case "/settings":
      return "Settings";
    default:
      if (pathname.startsWith("/jobs/edit/")) {
        return "Edit Job";
      }
      if (
        pathname.startsWith("/jobs/all/") &&
        pathname.includes("/containers")
      ) {
        return "Containers";
      }
      if (pathname.startsWith("/transporters/")) {
        if (pathname.includes("/edit/")) {
          return "Edit Transporter";
        }
        if (pathname.includes("/details/")) {
          return "Transporter Details";
        }
        return "Transporters";
      }
      if (pathname.startsWith("/drivers/")) {
        if (pathname.includes("/edit/")) {
          return "Edit Driver";
        }
        if (pathname.includes("/details/")) {
          return "Driver Details";
        }
        return "Drivers";
      }
      return "";
  }
};

// Cache for job codes to avoid repeated API calls
const jobCodeCache: { [key: string]: string } = {};

// Async function to get job code
const getJobCode = async (jobId: string): Promise<string> => {
  // Check cache first
  if (jobCodeCache[jobId]) {
    return jobCodeCache[jobId];
  }

  try {
    const response = await JobService.getJobDetails(parseInt(jobId));
    if (response.data && response.data.data) {
      const jobCode = response.data.data.jobCode;
      // Cache the result
      jobCodeCache[jobId] = jobCode;
      return jobCode;
    }
  } catch (error) {
    console.error("Error fetching job code:", error);
  }
  return jobId; // Fallback to job ID if fetch fails
};

export const getSubPageTitle = (pathname: string): string => {
  if (pathname.includes("/jobs/all/") && pathname.includes("/containers")) {
    if (pathname.includes("/live-tracking")) {
      return "Live Tracking";
    }
    if (pathname.includes("/containers/")) {
      return "Trip Details";
    }
    return "Containers";
  }

  if (pathname.startsWith("/job/")) {
    if (pathname.includes("/containers")) {
      return "Containers";
    }
    if (pathname.includes("/assign-containers")) {
      return "Assign Containers";
    }
    return "Job Details";
  }

  if (pathname.startsWith("/transporters/")) {
    if (pathname.includes("/edit/")) {
      return "Edit Transporter";
    }
    if (pathname.includes("/details/")) {
      return "Transporter Details";
    }
    return "Transporters";
  }

  if (pathname.startsWith("/drivers/")) {
    if (pathname.includes("/edit/")) {
      return "Edit Driver";
    }
    if (pathname.includes("/details/")) {
      return "Driver Details";
    }
    return "Drivers";
  }

  if (pathname.startsWith("/trucks/")) {
    if (pathname.includes("/edit/")) {
      return "Edit Truck";
    }
    if (pathname.includes("/details/")) {
      return "Truck Details";
    }
    return "Trucks";
  }

  if (pathname.startsWith("/fleet/")) {
    if (pathname.includes("/drivers")) {
      return "Drivers";
    }
    if (pathname.includes("/trucks")) {
      return "Trucks";
    }
    return "Fleet";
  }

  return "";
};
